import { ErrorMessages } from '@constants/common/messages.constants';

export enum ErrorStatusCode {
  InternalServerError = 500,
}

export enum ServerError {
  SignatureIsExpired = 'signature is expired',
  SignerIsNotOwner = 'Signer is not contract owner or publisher',
  FailedSigner = 'Failed to recover signer',
  IncorrectLink = 'Incorrect link',
  PairNotExists = 'Pair not exists',
}

export const ERROR_MESSAGE_MAP: Record<ServerError, ErrorMessages> = {
  [ServerError.SignatureIsExpired]: ErrorMessages.SignatureIsExpired,
  [ServerError.SignerIsNotOwner]: ErrorMessages.SignerIsNotOwner,
  [ServerError.FailedSigner]: ErrorMessages.FailedSigner,
  [ServerError.IncorrectLink]: ErrorMessages.IncorrectLink,
  [ServerError.PairNotExists]: ErrorMessages.PairNotExists,
};

export enum ErrorWagmiMap {
  UserRejected = 'User rejected the request.',
  InsufficientBalance = 'transfer amount exceeds balance',
  InsufficientTransactionBalance = 'transaction exceeds the balance',
  InvalidAddressError = 'Address must be',
  InsufficientGas = 'The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account.',
}

export const ERROR_WAGMI_MESSAGE_MAP: Record<ErrorWagmiMap, ErrorMessages> = {
  [ErrorWagmiMap.UserRejected]: ErrorMessages.UserRejected,
  [ErrorWagmiMap.InsufficientBalance]: ErrorMessages.InsufficientBalance,
  [ErrorWagmiMap.InsufficientTransactionBalance]:
    ErrorMessages.InsufficientBalance,
  [ErrorWagmiMap.InsufficientGas]: ErrorMessages.InsufficientBalance,
  [ErrorWagmiMap.InvalidAddressError]: ErrorMessages.InvalidAddressError,
};
